import React, {useEffect, useMemo, useState} from 'react';
import {Avatar, Box, Button, Chip, CircularProgress, Divider, Fab, Grid, IconButton, InputAdornment, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography} from "@mui/material";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import {useTheme} from "@mui/material/styles";
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from "@mui/icons-material/Search";
import TablePaginationActions from '@mui/material/TablePagination/TablePaginationActions';
import MainCard from '../../../utils/ui-components/MainCard';
import { gridSpacing } from '../../../store/constants';
import EmptyResult from '../../../utils/ui-components/EmptyResult';
import Spinner from '../../../utils/ui-components/Spinner';
import { SuperAdminService } from '../../../assets/_services/super-admin-service';
import { closeConfirmDialog, openConfirmDialog } from '../../../utils/ui-components/pop-ups/ConfirmDialog';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import { openSuccessDialog } from '../../../utils/ui-components/pop-ups/SuccessDialog';


function CompanyList() {

    const theme: any = useTheme();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingStatus, setIsLoadingStatus] = useState({loading : false, id : ""})
    const [search, setSearch] = useState("");
    const [companyData, setCompanyData]: any = useState([]);
    const [count, setCount] = useState(0);
       
    useEffect(() => {
        fetchData();
    }, [page,rowsPerPage])

    const fetchData = () => {
        setIsLoading(true)
        SuperAdminService.getCompaniesforSuperAdmin(page,rowsPerPage).then(
            response => {
                if(response.isSuccess){
                    setCompanyData(response.data.data.rows)
                    setCount(response.data.data.count)
                    setIsLoading(false)
                }
            }
        )
    }

    const changeStatusCompany = (data: { id: string, status: number }) => {
        setIsLoadingStatus({
            loading : true,
            id : data.id
        })
        closeConfirmDialog()
        let formData = {
            companyId : data.id,
            activeStatus : data.status ? 0 : 1
        }
        SuperAdminService.changeCompanyStatusforSuperAdmin(formData).then(
            response =>{
                if(response.isSuccess){
                    openSuccessDialog("Success", response.data.comment )
                    if(search === ""){
                        fetchData();
                    }else{
                        fetchData()
                    }
                    setIsLoadingStatus({
                        loading : false,
                        id : ""
                    })
                }else{
                    setIsLoadingStatus({
                        loading : false,
                        id : ""
                    })
                }
            }
        )
    }

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Grid container>
            <Grid container justifyContent="center">
                <Grid item lg={10} md={10} sm={12} xs={12}>
                    <MainCard title="Company List">
                        <Grid container spacing={gridSpacing}>
                            <Grid item lg={5} md={5} sm={12} xs={12}>
                                <TextField
                                    label="Search"
                                    placeholder="Search team name.."
                                    value={search}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setSearch(event.target.value);
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon/>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{...theme.typography.customInput}}
                                    fullWidth={true}
                                />
                            </Grid>
                            <Grid item lg={3} md={3} sm={12} xs={12}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    sx={{...theme.typography.customInput}}
                                    type="button"
                                    onClick={()=>{
                                        setPage(0)
                                        // searchTeamList()
                                    }}
                                >
                                    View
                                </Button>
                            </Grid>
                        </Grid>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">company Name</TableCell>
                                        <TableCell align="center" width={"40%"}>Company Number</TableCell>
                                        <TableCell align="center" width={"20%"}>Company Email</TableCell>
                                        <TableCell align="center" width={"20%"}>Company Address</TableCell>
                                        <TableCell align="center" width={"20%"}>groupId3cx</TableCell>
                                        <TableCell align="center">Status</TableCell>
                                        <TableCell width={'5%'}/>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {companyData?.length > 0 && !isLoading && companyData.map((item: any, index : number) => (
                                        <TableRow hover key={index} >
                                            <TableCell align="center" width={'20%'}>{item?.companyName}</TableCell>
                                            <TableCell align="center">{item?.companyNumber}</TableCell>
                                            <TableCell align="center">{item?.companyEmail}</TableCell>
                                            <TableCell align="center">{item?.companyAddress} {item?.city}</TableCell>
                                            <TableCell align="center">{item?.groupId3cx ?
                                                <Typography variant="overline"
                                                            color='success.main'>Yes</Typography> :
                                                <Typography variant="overline"
                                                            color='error.main'>No</Typography>}
                                            </TableCell>
                                            <TableCell align="center">{item?.activeStatus ?
                                                <Typography variant="overline"
                                                            color='success.main'>Active</Typography> :
                                                <Typography variant="overline"
                                                            color='error.main'>Inactive</Typography>}
                                            </TableCell>
                                            <TableCell align="right">
                                                {item?.activeStatus === 1 ? (
                                                    <Tooltip title="Deavtive">
                                                        <span>
                                                        <IconButton
                                                            color="error"
                                                            aria-label="view"
                                                            onClick={() => openConfirmDialog(
                                                                "Deactivate Company",
                                                                `Are you sure you want to deactivate this company?`,
                                                                {
                                                                    id: item._id,
                                                                    status: item.activeStatus,
                                                                },
                                                                (data) => changeStatusCompany(data)
                                                            )}
                                                        >
                                                            {isLoadingStatus.loading && isLoadingStatus.id === item.id ? <CircularProgress size={'20px'} sx={{color:'gray' }} /> :<StopIcon
                                                                fontSize="inherit"
                                                            />}
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    ):
                                                    (
                                                        <Tooltip title="Active">
                                                            <span>
                                                            <IconButton
                                                                color="primary"
                                                                aria-label="view"
                                                                onClick={() => openConfirmDialog(
                                                                    "Active Contact",
                                                                    `Are you sure you want to active this contact?`,
                                                                    {
                                                                        id: item._id,
                                                                        status: item.activeStatus,
                                                                    },
                                                                    (data) => changeStatusCompany(data)
                                                                )}
                                                            >
                                                                {isLoadingStatus.loading && isLoadingStatus.id === item.id ? <CircularProgress size={'20px'} sx={{color:'gray' }} /> :<PlayArrowIcon
                                                                    fontSize="inherit"
                                                                />}
                                                            </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        )
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            {!companyData?.length && !isLoading ? <EmptyResult/> : isLoading ? <Box
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    minHeight: "40vh",
                                }}
                            >
                                <Spinner/>
                            </Box> : null}
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 100]}
                                component="div"
                                count={count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableContainer>
                    </MainCard>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default CompanyList;